module.exports = __webpack_public_path__ + "static/media/404.152a3506.png";